// translations/fr.ts
import { TranslationKeys } from '../index';

export const fr: TranslationKeys = {
  header: {
    tutorialButton: "Tutoriels",
    currentLanguage: "Actuel"
  },
  hero: {
    title: "Jouez à Sudoku Vs Maintenant !",
    description: "Préparez-vous à un défi de Sudoku comme aucun autre ! Profitez de la pratique en solo ou affrontez des amis — téléchargez maintenant et vivez l'excitation !",
    howToPlay: "Comment Jouer",
    googlePlay: {
      topText: "Disponible sur",
      bottomText: "Google Play"
    },
    appStore: {
      topText: "Télécharger dans l'",
      bottomText: "App Store"
    },
    botButtonShow: "Besoin d'aide ? Demandez à notre Bot !",
    botButtonHide: "Cacher l'Assistant"
  },
  footer: {
    followUs: "SUIVEZ-NOUS SUR",
    handle: "@SUDOKU.VS",
    copyright: "© 2024 Sudoku VS. Tous droits réservés."
  },
  beginnersGuide: {
    modalTitle: "GUIDE DU DÉBUTANT",
    originsTab: "ORIGINES DU SUDOKU",
    basicsTab: "LES BASES DU SUDOKU",
    rulesTab: "RÈGLES DU JEU VS",
    origins: {
      bulletOne: "Inspiré des carrés latins ; publié pour la première fois en 1979 par Howard Garns.",
      bulletTwo: "Devenu populaire au Japon dans les années 1980, renommé “Sudoku”. A acquis une renommée mondiale dans les années 2000.",
      bulletThree: "Grille 9x9 avec neuf sous-grilles 3x3 ; remplir avec des chiffres de 1 à 9 sans répétition dans les lignes, colonnes ou sous-grilles.",
      bulletFour: "Apprécié par des millions de personnes, avec de nombreuses variations et de nouveaux défis.",
      gridSize: {
        four: "4 X 4",
        six: "6 X 6",
        nine: "9 X 9",
      }
    },
    basics: {
      fillMissing: "Remplissez le numéro manquant !",
      correct: "CORRECT !",
      incorrect: "INCORRECT",
      instructions: "Complétez le puzzle 3X3 en entrant le bon numéro pour l'espace en surbrillance. Chaque ligne, colonne et boîte doit contenir chaque numéro exactement une fois. Sélectionnez le bon numéro. Choisissez judicieusement !",
      feedbackCorrect: "VOUS AVEZ RÉSOLU VOTRE PREMIÈRE BOÎTE !",
      feedbackIncorrect: "ESSAYEZ ENCORE !",
      basicsStep2: {
        instructions: "Complétez le puzzle 4X4 en sélectionnant le bon numéro pour l'espace en surbrillance. Chaque ligne, colonne et boîte doit contenir chaque numéro exactement une fois. Sélectionnez le bon numéro. Choisissez judicieusement !",
        feedbackCorrect: "VOUS ÊTES SUR UNE LANCÉE !"
      },
      basicsStep3: {
        instructions: "Complétez le puzzle 4X4 en sélectionnant le bon numéro pour l'espace en surbrillance. Chaque ligne, colonne et boîte doit contenir chaque numéro exactement une fois. Sélectionnez le bon numéro. Choisissez judicieusement !",
        feedbackCorrect: "SOLUTION PARFAITE !",
        feedbackIncorrect: "INCORRECT - ESSAYEZ ENCORE !"
      },
      congratulations: {
        title: "Félicitations !",
        subtitle: "Vous avez terminé avec succès le tutoriel sur les bases du Sudoku ! Votre dévouement et vos efforts ont porté leurs fruits, et vous êtes maintenant équipé des compétences essentielles pour aborder les puzzles de Sudoku avec confiance.",
        nextStepsTitle: "Prochaines Étapes",
        nextStepsText: "Il est maintenant temps de mettre vos compétences à l'épreuve ! Téléchargez le jeu de Sudoku aujourd'hui et plongez dans une variété de puzzles. Que vous préfériez une partie rapide en solo ou que vous souhaitiez vous lancer dans une compétition amicale, vous pouvez choisir de jouer en mode solo ou en mode vs contre un adversaire.",
        ctaHeader: "Prêt pour une partie ?",
        ctaHighlight: "Téléchargez Maintenant !",
        rulesTitle: "Maîtrisez les Règles du Jeu",
        rulesText: "Avant de vous lancer, assurez-vous de consulter les Règles du Jeu de Sudoku VS. Comprendre les règles et le système de points peut vous donner un avantage lorsque vous jouez contre des adversaires. Ces connaissances amélioreront votre expérience et vous aideront à élaborer des stratégies efficaces !"
      }
    },
    gameRules: {
      notification: {
        important: "Important : ",
        text: "Activez les notifications pour une meilleure expérience !"
      },
      rulesHeader: "Règles",
      rulesList: {
        rule1_pre: "Acceptez ou créez une invitation à un ",
        rule1_strong: "match amical ou aléatoire",
        rule1_post: ".",
        rule2_pre: "Un joueur est ",
        rule2_strong: "sélectionné au hasard pour commencer.",
        rule3: "Les joueurs jouent à tour de rôle jusqu'à ce que le plateau soit complet.",
        rule4_pre1: "Chaque ",
        rule4_strong1: "tour dure 60 secondes,",
        rule4_pre2: " avec une limite de ",
        rule4_strong2: "5 numéros par tour.",
        rule5_pre: "Seulement ",
        rule5_strong: "1 indice",
        rule5_post: " est autorisé par tour.",
        rule6_pre: "Le joueur avec ",
        rule6_strong: "le score le plus élevé gagne",
        rule6_post: " la partie.",
        rule7_pre: "En cas d'",
        rule7_strong_pre: "égalité",
        rule7_pre2: ", le joueur avec le plus de saisies ",
        rule7_strong_post: "gagne",
        rule7_post: " la partie.",
        rule8: "Si vous ne terminez pas votre tour dans les 24 heures, vous perdez automatiquement la partie."
      },
      rulesWarning: "Jouez votre tour dans les 24 heures ou vous perdrez automatiquement la partie",
      gameControls: {
        header: "Contrôles du Jeu",
        list: {
          control1_pre: "Utilisez le ",
          control1_strong: "Drapeau d'Abandon",
          control1_post: " pour abandonner la partie.",
          control2_pre: "Utilisez la ",
          control2_strong: "Gomme",
          control2_post: " pour corriger une erreur.",
          control3_pre: "Utilisez ",
          control3_strong: "Fin du Tour",
          control3_post: " si vous avez complété toutes vos saisies avant la fin du temps imparti."
        }
      },
      scoring: {
        header: "Score",
        list: {
          score1_pre1: "Gagnez ",
          score1_strong1: "1 point",
          score1_pre2: " pour un placement de numéro ",
          score1_span: "correct",
          score1_post: ".",
          score2_pre1: "Perdez ",
          score2_strong1: "1 point",
          score2_pre2: " pour chaque placement de numéro ",
          score2_span: "incorrect",
          score2_post: ".",
          score3_pre1: "Gagnez ",
          score3_strong1: "5 points",
          score3_pre2: " pour chaque ligne, colonne et boîte ",
          score3_span: "résolue",
          score3_post: "."
        }
      },
    },
    controller: {
      previous: "Précédent",
      of: " sur ",
      close: "Fermer",
      next: "Suivant",
      gameRules: "Règles du Jeu",
    },
  },
  tutorials: {
    modalTitle: "Tutoriels",
    tabs: {
      introduction: "Introduction",
      gettingStarted: "Pour Commencer",
      vsFriends: "Contre des Amis",
      howToPlay: "Comment Jouer",
    },
    messages: {
      loading: "Chargement des tutoriels...",
      error: "Erreur lors du chargement des tutoriels :",
      fallback: "Utilisation des données de secours...",
      empty: "Aucun tutoriel disponible pour cette section.",
    },
  },
  cookieConsent: {
    title: "Gérer les Préférences de Consentement",
    description: "Nous utilisons des cookies pour améliorer votre expérience sur Sudoku VS, analyser notre trafic et fournir des publicités personnalisées.",
    acceptAll: "Accepter tous les Cookies",
    confirmChoices: "Confirmer les Choix",
    performance: {
      title: "Cookies de Performance",
      description: "Nous permettent de collecter des données pour améliorer notre jeu et nos services grâce à l'analyse de l'utilisation."
    },
    advertising: {
      title: "Publicité",
      adStorage: "Autorise le stockage de données publicitaires sur votre appareil.",
      adMeasurement: "Autorise la collecte de données pour la mesure de la publicité.",
      adPersonalization: "Nous permet de vous montrer des publicités personnalisées en fonction de vos intérêts."
    },
    landing: {
        title: "Avis sur les Cookies",
        description: "Nous utilisons des cookies pour améliorer votre expérience sur Sudoku VS, analyser notre trafic et fournir des publicités personnalisées. Vous pouvez définir les cookies que vous souhaitez autoriser avant de continuer.",
        acceptAll: "Accepter tous les Cookies",
        customizeSettings: "Personnaliser les Paramètres",
        fineprint: "En cliquant sur \"accepter tous les cookies\", vous acceptez que<br />Sudoku VS puisse stocker des cookies sur votre appareil."
    }
  },
languages: {
    en: "English",
    es: "Español", 
    fr: "Français",
    hi: "हिन्दी",
    bn: "বাংলা",
    pt: "Português",
    it: "Italiano",
    ru: "Русский",
    ja: "日本語",
    ko: "한국어"
},

  privacyPolicy: {
    modalTitle: "Politique de Confidentialité",
    sections: {
      introduction: {
        title: "1. Introduction",
        p1: "Bienvenue sur Sudoku VS. Nous nous engageons à protéger votre vie privée et à vous assurer une expérience positive sur notre site web. Cette Politique de Confidentialité explique comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre plateforme de jeu Sudoku.",
        p2: "En utilisant Sudoku VS, vous acceptez la collecte et l'utilisation des informations conformément à cette politique."
      },
      informationWeCollect: {
        title: "2. Informations que Nous Collectons",
        p1: "Nous collectons différents types d'informations pour fournir et améliorer nos services:",
        list: {
          usageData: "Données d'Utilisation: Nous collectons automatiquement des informations sur la façon dont vous interagissez avec notre jeu, y compris les statistiques de jeu, les temps de résolution des puzzles, les niveaux de difficulté joués et les préférences de jeu.",
          deviceInfo: "Informations sur l'Appareil: Nous pouvons collecter des informations sur l'appareil que vous utilisez pour accéder à Sudoku VS, y compris le type d'appareil, le type de navigateur, l'adresse IP et le système d'exploitation.",
          cookies: "Cookies et Données de Suivi: Nous utilisons des cookies et des technologies de suivi similaires pour améliorer votre expérience et collecter des données analytiques."
        }
      },
      howWeUseInfo: {
        title: "3. Comment Nous Utilisons Vos Informations",
        p1: "Nous utilisons les informations collectées aux fins suivantes:",
        list: {
          gameImprovement: "Amélioration du Jeu: Pour analyser les modèles de jeu et améliorer nos puzzles Sudoku, algorithmes de difficulté et l'expérience utilisateur globale.",
          performanceAnalytics: "Analytique de Performance: Pour surveiller et analyser les tendances d'utilisation, mesurer l'efficacité de nos services et identifier les domaines d'amélioration.",
          personalization: "Personnalisation: Pour vous fournir des recommandations de jeu personnalisées et un contenu adapté basé sur vos préférences de jeu.",
          technicalSupport: "Support Technique: Pour résoudre les problèmes, corriger les bugs et assurer le bon fonctionnement de notre plateforme."
        }
      },
      cookies: {
        title: "4. Cookies et Technologies de Suivi",
        p1: "Sudoku VS utilise des cookies pour améliorer votre expérience. Vous avez la possibilité de gérer vos préférences en matière de cookies:",
        performanceCookies: {
          title: "Cookies de Performance:",
          description: "Ces cookies nous permettent de collecter des données pour améliorer notre jeu et nos services grâce à l'analyse d'utilisation. Ils nous aident à comprendre comment les joueurs interagissent avec nos puzzles, quelles fonctionnalités sont les plus populaires et où nous pouvons apporter des améliorations. Ces données sont essentielles pour améliorer le gameplay et créer de meilleures expériences Sudoku."
        },
        advertisingCookies: {
          title: "Cookies Publicitaires:",
          list: [
            "Permettent le stockage de données publicitaires sur votre appareil",
            "Permettent la collecte de données pour la mesure et l'efficacité de la publicité",
            "Nous permettent de vous montrer des publicités personnalisées basées sur vos intérêts et votre comportement de jeu"
          ]
        },
        p2: "Vous pouvez contrôler vos préférences de cookies via la bannière de consentement aux cookies qui apparaît lorsque vous visitez notre site web pour la première fois. Vous pouvez modifier vos paramètres à tout moment via les paramètres de votre navigateur, bien que la désactivation de certains cookies puisse affecter la fonctionnalité du site web."
      },
      thirdParty: {
        title: "5. Services Tiers",
        p1: "Sudoku VS s'intègre avec les services tiers suivants:",
        gemini: {
          title: "Assistant IA Google Gemini:",
          description: "Notre bot d'aide est alimenté par Google Gemini avec une base de connaissances intégrée pour vous aider avec les questions liées au jeu, fournir des conseils Sudoku et aider à résoudre les problèmes. Lorsque vous interagissez avec le bot, vos requêtes peuvent être traitées par les systèmes de Google. Veuillez consulter la Politique de Confidentialité de Google pour plus d'informations sur la façon dont ils traitent les données."
        },
        youtube: {
          title: "VidÉos Intégrées YouTube:",
          description: "Nous utilisons des superpositions vidéo YouTube pour fournir du contenu tutoriel et des guides de jeu directement dans notre site web. Lorsque vous interagissez avec ces vidéos, YouTube peut collecter des données conformément à sa politique de confidentialité. Vous pouvez regarder des vidéos sans quitter Sudoku VS, mais les mécanismes de suivi de YouTube peuvent toujours s'appliquer."
        },
        advertising: {
          title: "Partenaires Publicitaires:",
          description: "Nous travaillons avec des partenaires publicitaires tiers pour afficher des publicités sur notre plateforme. Ces partenaires peuvent utiliser des cookies et des technologies similaires pour collecter des informations sur votre activité de navigation à des fins de publicité personnalisée."
        }
      },
      dataSecurity: {
        title: "6. Sécurité des Données",
        p1: "Nous prenons la sécurité de vos données au sérieux et mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos informations contre l'accès, l'altération, la divulgation ou la destruction non autorisés. Cependant, veuillez noter qu'aucune méthode de transmission sur Internet ou de stockage électronique n'est 100% sûre.",
        p2: "Notre site web utilise des protocoles de sécurité standard de l'industrie et est vérifié par le sceau de sécurité GoDaddy pour garantir une expérience de navigation sûre."
      },
      privacyRights: {
        title: "7. Vos Droits à la Vie Privée",
        p1: "Vous avez certains droits concernant vos informations personnelles:",
        list: {
          access: "Accès: Vous pouvez demander des informations sur les données que nous détenons à votre sujet",
          correction: "Correction: Vous pouvez demander la correction d'informations inexactes",
          deletion: "Suppression: Vous pouvez demander la suppression de vos données, sous réserve d'obligations légales",
          optOut: "Désinscription: Vous pouvez vous désinscrire de la publicité personnalisée via vos préférences de cookies",
          portability: "Portabilité des Données: Vous pouvez demander une copie de vos données dans un format portable"
        }
      },
      childrenPrivacy: {
        title: "8. Confidentialité des Enfants",
        p1: "Sudoku VS est conçu pour un public général. Nous ne collectons pas sciemment d'informations personnelles d'enfants de moins de 13 ans. Si vous êtes parent ou tuteur et que vous pensez que votre enfant nous a fourni des informations personnelles, veuillez nous contacter afin que nous puissions prendre les mesures appropriées."
      },
      changes: {
        title: "9. Modifications de cette Politique de Confidentialité",
        p1: "Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre pour refléter les changements dans nos pratiques ou pour des raisons légales, opérationnelles ou réglementaires. Nous vous informerons de tout changement important en publiant la nouvelle Politique de Confidentialité sur cette page et en mettant à jour la date de « Dernière mise à jour » ci-dessous.",
        p2: "Nous vous encourageons à consulter cette Politique de Confidentialité périodiquement pour rester informé sur la façon dont nous protégeons vos informations."
      },
      contact: {
        title: "10. Contactez-Nous",
        p1: "Si vous avez des questions, des préoccupations ou des demandes concernant cette Politique de Confidentialité ou nos pratiques en matière de données, veuillez nous contacter:",
        email: "Email: privacy@sudoku.vs",
        website: "Site web: www.sudoku.vs",
        p2: "Nous répondrons à votre demande dans les plus brefs délais."
      }
    },
    footer: {
      lastUpdated: "Dernière mise à jour: 10 octobre 2025",
      effectiveDate: "Date d'effet: 10 octobre 2025"
    }
  },
  copywright: {
    text: 'Copyright © 2025 Software Architects Ltd. Tous droits réservés.'
  }
};